import { render, staticRenderFns } from "./QandA.vue?vue&type=template&id=644a8a05&scoped=true"
import script from "./QandA.vue?vue&type=script&lang=js"
export * from "./QandA.vue?vue&type=script&lang=js"
import style0 from "./QandA.vue?vue&type=style&index=0&id=644a8a05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a8a05",
  null
  
)

export default component.exports